export enum LocalStorageKeys {
  AccessToken = "access-token",
  RefreshToken = "refresh-token",
  SupportAccessToken = "support-access-token",
  SupportRefreshToken = "support-refresh-token",
  usersCsvReport = "Societe_Users.csv.report-meta",
  affiliateUsersCsvReport = "Societe_Affiliates.csv.report-meta",
  referralsUsersCsvReport = "Societe_Referrals.csv.report-meta",
  affiliatePaymentsXlsxReport = "Societe_Payments.xlsx.report-meta",
}

type ProfileEncryptedData = {
  _id: string;
  email: string;
  iat: number;
  exp: number;
};

export type FileReportMeta = {
  date: string;
  count: number;
};

class LocalStorageService {
  private static readonly accessTokenKey = LocalStorageKeys.AccessToken;
  private static readonly refreshTokenKey = LocalStorageKeys.RefreshToken;
  private static readonly supportAccessTokenKey =
    LocalStorageKeys.SupportAccessToken;
  private static readonly supportRefreshTokenKey =
    LocalStorageKeys.SupportRefreshToken;

  static getSupportAccessToken(): string | null {
    return localStorage.getItem(this.supportAccessTokenKey);
  }

  static setSupportAccessToken(token: string): void {
    localStorage.setItem(this.supportAccessTokenKey, token);
  }

  static deleteSupportAccessToken(): void {
    localStorage.removeItem(this.supportAccessTokenKey);
  }

  static getSupportRefreshToken(): string | null {
    return localStorage.getItem(this.supportRefreshTokenKey);
  }

  static setSupportRefreshToken(token: string): void {
    localStorage.setItem(this.supportRefreshTokenKey, token);
  }

  static deleteSupportRefreshToken(): void {
    localStorage.removeItem(this.supportRefreshTokenKey);
  }

  static deleteSupportAuthTokens(): void {
    this.deleteSupportAccessToken();
    this.deleteSupportRefreshToken();
  }

  static getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }

  static setAccessToken(token: string): void {
    localStorage.setItem(this.accessTokenKey, token);
  }

  static deleteAccessToken(): void {
    localStorage.removeItem(this.accessTokenKey);
  }

  static getRefreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenKey);
  }

  static setRefreshToken(token: string): void {
    localStorage.setItem(this.refreshTokenKey, token);
  }

  static deleteRefreshToken(): void {
    localStorage.removeItem(this.refreshTokenKey);
  }

  static deleteAuthTokens(): void {
    this.deleteAccessToken();
    this.deleteRefreshToken();
  }

  static getFileReportMeta(key: string): FileReportMeta | null {
    const item = localStorage.getItem(key);

    if (!item) return null;
    return JSON.parse(item);
  }

  static setFileReportMeta(key: string, meta: FileReportMeta): void {
    localStorage.setItem(key, JSON.stringify(meta));
  }

  static getMyId() {
    const accessToken = this.getAccessToken();

    if (accessToken) {
      const encryptedData = accessToken.split(".")[1];

      const { _id } = JSON.parse(
        atob(encryptedData as string),
      ) as ProfileEncryptedData;

      return _id;
    }
  }

  static getSupportUserId() {
    const supportAccessToken = this.getSupportAccessToken();

    if (supportAccessToken) {
      const encryptedData = supportAccessToken.split(".")[1];

      const { _id } = JSON.parse(
        atob(encryptedData as string),
      ) as ProfileEncryptedData;

      return _id;
    }
  }
}

export { LocalStorageService };
